import React from "react";
import type { TouchableWithoutFeedbackProps } from "react-native";

export const EnhancedTouchableWithoutFeedback: React.FC<
  TouchableWithoutFeedbackProps & { as: React.ReactElement }
> = ({ as, children, ...rest }) => {
  return React.cloneElement(as, rest, children);
};

export default EnhancedTouchableWithoutFeedback;
